<template>
  <v-dialog :value="value" max-width="700px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ device ? 'Edit Device' : 'Add Device' }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col v-for="field in fields" :key="field.key" :cols="field.cols">
              <v-select
                v-if="field.type === 'select'"
                v-model="form[field.key]"
                :label="field.label"
                :items="field.items"
                outlined dense
              ></v-select>
              <v-checkbox
                v-else-if="field.type === 'checkbox'"
                v-model="form[field.key]"
                :label="field.label"
                dense
              ></v-checkbox>
              <v-text-field
                v-else
                :value="form[field.key]"
                @input="form[field.key] = field.type === 'number' ? Number($event) : $event"
                :label="field.label"
                :placeholder="field.placeholder"
                :type="field.type === 'number' ? 'number' : 'text'"
                :step="field.step || undefined"
                outlined dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">
          {{ device ? 'Update' : 'Add' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiService } from '../../service/api.service'

export default {
  name: 'JetsonDeviceDialog',
  props: {
    value: { type: Boolean, default: false },
    device: { type: Object, default: null }
  },
  data () {
    return {
      saving: false,
      form: this.emptyForm(),
      fields: [
        { key: 'name', type: 'text', cols: 6, label: 'Name', placeholder: 'e.g., Jetson AGX Orin 64GB' },
        { key: 'slug', type: 'text', cols: 6, label: 'Slug', placeholder: 'e.g., jetson-agx-orin-64gb' },
        { key: 'series', type: 'text', cols: 6, label: 'Series', placeholder: 'e.g., Jetson AGX Orin Series' },
        { key: 'gpu_arch', type: 'select', cols: 6, label: 'GPU Architecture', items: ['Blackwell', 'Ampere', 'Volta', 'Maxwell'] },
        { key: 'unified_memory_gb', type: 'number', cols: 4, label: 'Memory (GB)', step: 0.1 },
        { key: 'tops', type: 'number', cols: 4, label: 'TOPS', step: 0.1 },
        { key: 'memory_bandwidth_gbs', type: 'number', cols: 4, label: 'Bandwidth (GB/s)', step: 0.1 },
        { key: 'cuda_cores', type: 'number', cols: 4, label: 'CUDA Cores' },
        { key: 'tensor_cores', type: 'number', cols: 4, label: 'Tensor Cores' },
        { key: 'power_w', type: 'text', cols: 4, label: 'Power (W)', placeholder: 'e.g., 15W-60W' },
        { key: 'compute_capability', type: 'text', cols: 4, label: 'Compute Capability', placeholder: 'e.g., 8.7' },
        { key: 'cpu_cores', type: 'number', cols: 4, label: 'CPU Cores' },
        { key: 'cpu_freq_ghz', type: 'number', cols: 4, label: 'CPU Freq (GHz)', step: 0.01 },
        { key: 'product_url', type: 'text', cols: 12, label: 'Product page (openzeka.com)', placeholder: 'https://openzeka.com/urun/...' },
        { key: 'image_url', type: 'text', cols: 12, label: 'Image URL', placeholder: 'https://openzeka.com/wp-content/uploads/...' },
        { key: 'preliminary', type: 'checkbox', cols: 12, label: 'Preliminary' }
      ]
    }
  },
  watch: {
    value (open) {
      if (open) {
        this.form = this.device ? { ...this.device } : this.emptyForm()
      }
    }
  },
  methods: {
    emptyForm () {
      return {
        slug: '',
        name: '',
        series: '',
        gpu_arch: 'Ampere',
        unified_memory_gb: null,
        tops: null,
        memory_bandwidth_gbs: null,
        cuda_cores: 0,
        tensor_cores: 0,
        power_w: '',
        compute_capability: '',
        cpu_cores: null,
        cpu_freq_ghz: null,
        product_url: '',
        image_url: '',
        preliminary: false
      }
    },
    async save () {
      this.saving = true
      try {
        if (this.device) {
          await apiService.put(`admin/llm_models/jetson-devices/${this.device.id}`, this.form)
          this.$emit('saved', 'Device updated')
        } else {
          await apiService.post('admin/llm_models/jetson-devices', this.form)
          this.$emit('saved', 'Device added')
        }
        this.$emit('input', false)
      } catch (e) {
        this.$emit('error', e.response?.data?.error || 'Save failed')
      }
      this.saving = false
    }
  }
}
</script>
